export default __webpack_public_path__ + "static/media/Azad-min.6a752244.webp";